export const getInitialVehicle = (state, payload) => {
  // returns vehicle object with "isInitVehicle: true" to use it as initial value
  if (payload?.isInitVehicle) return payload;
  // returns the checkoutVehicle object for the financing checkout calculator
  if (state.checkoutVehicle?.vehicle?.id) return state.checkoutVehicle.vehicle;

  return state.vehicle.vehicle;
};
